import { dateInRange, getTodayDate } from '@utils/date';

import { IBenefits } from '../../model';
import { hasActiveFreeDeliveryBenefit, hasFreeDeliveryVoucher } from '../../utils';

/**
 * Method decides whether the Free Delivery Progressbar should be rendered.
 * Render of free delivery wrapper is conditioned by:
 * - global free delivery feature settings
 * - vouchers
 * - benefits
 *
 * We do NOT render progress bar if customer has free delivery benefit.
 * We do render progress bar if customer has free delivery voucher.
 *
 * We do not render progress bar if global settings are not satisfied.
 * @param isMinimalPriceLimit - Free delivery progress calculated by delivery price limit
 * @param freeDelivery - Free delivery progress feature switch - decides if free delivery is enabled
 * @param freeDeliveryGlobalFrom - Starting date of free delivery
 * @param freeDeliveryGlobalTo - End date of free delivery
 * @param benefits - Customer benefits
 */

export const shouldBeRendered = (
  isMinimalPriceLimit: boolean,
  freeDelivery: boolean,
  freeDeliveryGlobalFrom: Date,
  freeDeliveryGlobalTo: Date,
  benefits: IBenefits,
): boolean => {
  return (
    (isMinimalPriceLimit ||
      freeDeliveryFSEnabled(freeDelivery, freeDeliveryGlobalFrom, freeDeliveryGlobalTo) ||
      hasFreeDeliveryVoucher(benefits.vouchers)) &&
    !hasActiveFreeDeliveryBenefit(benefits)
  );
};

export const freeDeliveryFSEnabled = (
  freeDelivery: boolean,
  freeDeliveryGlobalFrom: Date,
  freeDeliveryGlobalTo: Date,
): boolean => freeDelivery && dateInRange(getTodayDate(), freeDeliveryGlobalFrom, freeDeliveryGlobalTo);

export const calculateMaxLimit = (
  isMinimalPriceLimit: boolean,
  minimalPriceLimit: number,
  freeDelivery: boolean,
  freeDeliveryGlobalLimit: number,
  freeDeliveryGlobalFrom: Date,
  freeDeliveryGlobalTo: Date,
  benefits: IBenefits,
): number => {
  let maxLimit = freeDeliveryGlobalLimit;

  // free delivery is DISABLED but deliveryType priceLimit is active
  // OR
  // free delivery is ENABLED and deliveryType priceLimit is active and lower thant global limit
  if (
    (!freeDeliveryFSEnabled(freeDelivery, freeDeliveryGlobalFrom, freeDeliveryGlobalTo) && isMinimalPriceLimit) ||
    (freeDeliveryFSEnabled(freeDelivery, freeDeliveryGlobalFrom, freeDeliveryGlobalTo) &&
      isMinimalPriceLimit &&
      minimalPriceLimit < freeDeliveryGlobalLimit)
  ) {
    maxLimit = minimalPriceLimit;
  }

  if (hasFreeDeliveryVoucher(benefits.vouchers)) {
    maxLimit = 0;
  }

  return maxLimit;
};
